module.exports = __webpack_public_path__ + "img/screen-9.fb526252.jpg";